module.exports = __webpack_public_path__ + "img/chateau_vecquee_drink.65a9d941.jpg";